import { axios } from '@/utils/request'

const api = {
  operLog: '/system/operLog',
  loginLog: '/system/logininfor',
  job: '/stuff/job',
  jobLog: '/stuff/jobLog'
}

export default api

// OperLog
export function getOperLogList (parameter) {
  return axios({
    url: api.operLog + '/list',
    method: 'get',
    params: parameter
  })
}

export function delOperLog (parameter) {
  return axios({
    url: api.operLog + '/remove',
    method: 'post',
    params: parameter
  })
}
export function cleanOperLog () {
  return axios({
    url: api.operLog + '/clean',
    method: 'post'
  })
}
// LoginLog
export function getLoginLogList (parameter) {
  return axios({
    url: api.loginLog + '/list',
    method: 'get',
    params: parameter
  })
}
export function delLoginLog (parameter) {
  return axios({
    url: api.loginLog + '/remove',
    method: 'post',
    params: parameter
  })
}
export function cleanLoginLog () {
  return axios({
    url: api.loginLog + '/clean',
    method: 'post'
  })
}

export function getJobList (parameter) {
  return axios({
    url: api.job + '/list',
    method: 'get',
    params: parameter
  })
}
export function saveJob (parameter) {
  return axios({
    url: api.job + (parameter.jobId > 0 ? '/update' : '/save'),
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function delJob (parameter) {
  return axios({
    url: api.job + '/remove',
    method: 'post',
    params: parameter
  })
}

export function runJob (parameter) {
  return axios({
    url: api.job + '/run',
    method: 'post',
    params: parameter
  })
}

export const jobExport = api.job + '/export'

export function getJobLogList (parameter) {
  return axios({
    url: api.jobLog + '/list',
    method: 'get',
    params: parameter
  })
}
export function delJobLog (parameter) {
  return axios({
    url: api.jobLog + '/remove',
    method: 'post',
    params: parameter
  })
}
export function cleanJobLog () {
  return axios({
    url: api.jobLog + '/clean',
    method: 'post'
  })
}

export const jobLogExport = api.jobLog + '/export'

export const operLogExport = api.operLog + '/export'
